import { Cancel } from '@mui/icons-material';
import {
  Button,
  Divider,
  Drawer,
  FormControl,
  FormLabel,
  Grid2,
  TextField,
  Typography
} from '@mui/material';

import { Field, Form, Formik } from 'formik';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { SaveButton } from 'app/components';
import { translations } from 'locales/i18n';

import {
  revenueTypeSettingsValidationSchema,
  useRevenueTypeSettingsInitialValue
} from './validation';

interface RevenueTypeProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  revenueType: any | undefined;
  handleSaveClick: (values: any) => Promise<void>;
}

export const RevenueTypeDrawer = (props: RevenueTypeProps) => {
  const { t } = useTranslation();
  return (
    <Drawer
      anchor="right"
      open={props.open}
      PaperProps={{
        sx: { width: { xs: '70%', md: '35%', xl: '25%' } }
      }}
      onClose={() => props.setOpen(false)}
    >
      <Formik
        initialValues={useRevenueTypeSettingsInitialValue(props.revenueType)}
        onSubmit={values => props.handleSaveClick(values)}
        validationSchema={revenueTypeSettingsValidationSchema(t)}
        validateOnMount
      >
        {({ touched, errors, isValid }) => (
          <Form>
            <Grid2
              container
              padding={2}
              flexDirection={'column'}
              height={'100vh'}
              justifyContent={'flex-end'}
              gap={2}
              width={'100%'}
            >
              <Grid2 container size={12} gap={1} flexDirection={'column'}>
                <Typography variant="h5" fontWeight={'bold'}>
                  {props.revenueType?.id
                    ? t(translations.pages.billingSettings.revenueType.drawer.update())
                    : t(translations.pages.billingSettings.revenueType.drawer.create())}
                </Typography>
                <Divider />
              </Grid2>
              <Grid2 container direction={'column'} spacing={2}>
                <FormControl required fullWidth>
                  <FormLabel>
                    {t(translations.pages.billingSettings.revenueType.revenueTypeNumber())}
                  </FormLabel>
                  <Field
                    as={TextField}
                    id="revenueTypeNumber"
                    name="revenueTypeNumber"
                    error={touched.revenueTypeNumber && Boolean(errors.revenueTypeNumber)}
                    helperText={touched.revenueTypeNumber && errors.revenueTypeNumber}
                    size="small"
                  />
                </FormControl>
                <FormControl required fullWidth>
                  <FormLabel>{t(translations.common.description())}</FormLabel>
                  <Field
                    as={TextField}
                    id="description"
                    name="description"
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                    size="small"
                  />
                </FormControl>
              </Grid2>
              <Grid2 size={12} alignContent={'center'} marginTop={'auto'}>
                <Divider sx={{ marginLeft: 1, marginRight: 0.6, flex: 1 }} />
              </Grid2>
              <Grid2 container justifyContent={'flex-end'} gap={2} alignItems={'flex-end'}>
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<Cancel />}
                  onClick={() => props.setOpen(false)}
                >
                  {t(translations.common.cancel())}
                </Button>
                <SaveButton isSubmitting={false} isValid={isValid} />
              </Grid2>
            </Grid2>
          </Form>
        )}
      </Formik>
    </Drawer>
  );
};
